import type { Counters } from "../state/store";

type Props = { counters: Counters };

export function ProgressBar({ counters }: Props) {
  const total = Math.max(1, counters.total);
  const pct = Math.round((counters.mastered / total) * 100);
  return (
    <div className="space-y-1">
      <div className="h-2 rounded-full bg-outline-soft overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-success to-emerald-400 transition-all duration-300 ease-out rounded-full"
          style={{ width: `${pct}%` }}
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
          role="progressbar"
        />
      </div>
      <div className="text-xs text-fg-muted text-right tabular">
        {counters.mastered} / {counters.total} ({pct}%)
      </div>
    </div>
  );
}
